/**
 * KeyConfirm component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled key confirm.
 */
const KeyConfirm = styled.div<Props>`
  left:  ${(props) =>
    (props.alternateKeyboard ? 165 : 123) * Screen.widthRatio}px;;
  margin-right: ${22 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${43 * Screen.widthRatio}px;    
  top:  ${(props) =>
    (props.alternateKeyboard ? -84.5 : -73) * Screen.widthRatio}px;
  margin-right: ${22 * Screen.widthRatio}px;
  position: relative;
  width: ${(props) =>
    (props.alternateKeyboard ? 76 : 118) * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? Colors['dark'] : Colors['grey'])};
  text-align: center;
  justify-content: center;
  background-color: ${(props) =>
    props.focused ? Colors['key'] : Colors['keyBg']};
  font-size: ${16 * Screen.widthRatio}px;
  font-family: ${Fonts['regular']};
  border-radius: ${5 * Screen.widthRatio}px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.3);
  line-height ${44 * Screen.widthRatio}px;
`;

export default KeyConfirm;
